import React, { useState } from "react";
import { Link } from "react-router-dom";
import AnimatedElement from "../AnimatedElement";
import bancoestrella from "../../assets/images/Bancos/v2/bancos_estrella.png";
import exploreicon from "../../assets/images/Bancos/exploreicon.png";
import serviciosicon from "../../assets/images/Bancos/serviciosicon.png";
import portafolioicon from "../../assets/images/Bancos/portafolioicon.png";
import row1 from "../../assets/images/Bancos/row1.png";
import row2 from "../../assets/images/Bancos/row2.png";
import soluciones1 from "../../assets/images/Bancos/v2/section_soluciones.png";
import imgrect1 from "../../assets/images/Bancos/v2/consultoria.jpg";
import imgrect2 from "../../assets/images/Bancos/v2/warehouse.png";
import imgrect3 from "../../assets/images/Bancos/v2/mantenimiento.JPG";
import imgrect4 from "../../assets/images/Bancos/v2/construccion.png";
import imgrect5 from "../../assets/images/Bancos/v2/entrenamiento.jpg";
import icon from "../../assets/images/Bancos/v2/icon.png";
import { useTranslation } from "react-i18next";
import imgIngles from "../../assets/images/Bancos/v2/imgIngles.png";
import "../../i18next";
import { useLanguage } from "../../context/LanguageContext";

function SeccionBancos() {
  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const { languageContext } = useLanguage();

  //console.log('lenguaje:',languageContext);
  return (
    <>
      {/**seccion Bancos */}
      <section className="w-full mx-auto">
        <div className="p-8 pb-0 md:px-10 md:w-1/2 ">
          <AnimatedElement
            fromDirection="top"
            style={{ fontFamily: "Helvetica" }}
          >
            <h1 className="color-orange-atm mb-4 font-bold text-4xl md:text-8xl">
              {t("banks")}
            </h1>
            <hr
              className="relative color-orange-atm"
              style={{ borderTop: "2px solid", height: "32px" }}
            />
            <h2 className="text-darkBlueText font-bold text-3xl w-full md:text-6xl">
              {t("banksSection.subtitle1")}
            </h2>
            <p className="text-darkBlueText text-base w-full py-4 md:text-lg">
              {t("banksSection.text1")}
            </p>
          </AnimatedElement>
        </div>

        <div className="w-3/4 mx-auto md:hidden">
          <AnimatedElement
            fromDirection="topbancos"
            className="ml-5 md:ml-0 mt-16 md:mt-0"
          >
            <img
              className="md:top-[200px] "
              src={bancoestrella}
              alt="banks star"
            />
          </AnimatedElement>
        </div>
        <div className="grid md:grid-cols-2 md:grid-flow-row md:gap-1 md:mt-28">
          <div className="md:row-span-2 mb-6">
            <AnimatedElement
              fromDirection="left"
              style={{ fontFamily: "Helvetica" }}
              className="w-5/6 mx-auto"
            >
              <img
                src={exploreicon}
                alt="explore_banks_icon"
                className=" md:relative  md:mx-0 md:my-4"
              />
              <h3 className="text-customDarkBlue text-3xl top-4 left-28  w-full py-4 mx-auto md:w-full md:mx-0 font-bold md:text-4xl">
                {t("banksSection.subtitle2")}
              </h3>
              <p className=" text-customDarkBlue mx-auto w-full md:mx-0 text-base ">
                {t("banksSection.text2")}
              </p>
              <div className="md:w-3/4 mx-auto flex md:flex-row md:justify-start py-4 md:flex-nowrap">
                <Link
                  to="/contactenos"
                  className="md:relative  md:left-3/4"
                  style={{
                    backgroundColor: "#19235C",
                    color: "#FFFFFF",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "2px",
                    padding: "10px 5px 10px 10px",
                    fontSize: "16px",
                    cursor: "pointer",
                    color: "white",
                    border: "none",
                    borderRadius: "12px",
                  }}
                >
                  {t("banksSection.btnContactUs")}
                  <img
                    src={icon}
                    alt="right_arrow_icon"
                    className="button-icon  p-2"
                    style={{ width: "24px", height: "24px", color: "white" }}
                  />
                </Link>
              </div>
            </AnimatedElement>
          </div>

          <div className="md:row-span-6 ">
            <AnimatedElement
              fromDirection="topbancos"
              className="hidden md:inline ml-5 md:ml-0 mt-16 md:mt-0"
            >
              <img
                className="md:top-[200px] md:p-8 w-full object-cover"
                src={bancoestrella}
                alt="img_bank_star"
              />
            </AnimatedElement>
          </div>

          <div className="md:row-span-2 mb-6">
            <AnimatedElement
              fromDirection="left"
              style={{ fontFamily: "Helvetica" }}
              className="w-5/6 mx-auto"
            >
              <img
                src={serviciosicon}
                alt="services_banks_icon"
                className=" md:relative  md:mx-0 md:my-4"
              />
              <h3 className="text-customDarkBlue text-3xl top-4 left-28  w-full py-4 mx-auto md:w-full md:mx-0 font-bold md:text-4xl">
                {t("banksSection.subtitle4")}
              </h3>
              <p className=" text-customDarkBlue mx-auto w-full md:mx-0 text-base ">
                {t("banksSection.text4")}
              </p>
              <div className="md:w-3/4 mx-auto flex md:flex-row md:justify-start py-4 md:flex-nowrap">
                <Link
                  to="/contactenos"
                  className="md:relative  md:left-3/4"
                  style={{
                    backgroundColor: "#19235C",
                    color: "#FFFFFF",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "2px",
                    padding: "10px 5px 10px 10px",
                    fontSize: "16px",
                    cursor: "pointer",
                    color: "white",
                    border: "none",
                    borderRadius: "12px",
                  }}
                >
                  {t("banksSection.btnContactUs")}
                  <img
                    src={icon}
                    alt="right_arrow_icon"
                    className="button-icon  p-2"
                    style={{ width: "24px", height: "24px", color: "white" }}
                  />
                </Link>
              </div>
            </AnimatedElement>
          </div>

          <div className="md:row-span-2">
            <AnimatedElement
              fromDirection="left"
              style={{ fontFamily: "Helvetica" }}
              className="w-5/6 mx-auto"
            >
              <img
                src={portafolioicon}
                alt="portafolio_icon"
                className=" md:relative  md:mx-0 md:my-4"
              />
              <h3 className="text-customDarkBlue text-3xl top-4 left-28  w-full py-4 mx-auto md:w-full md:mx-0 font-bold md:text-4xl">
                {t("banksSection.subtitle3")}
              </h3>
              <p className=" text-customDarkBlue mx-auto w-full md:mx-0 text-base ">
                {t("banksSection.text3")}
              </p>
              <div className="md:w-3/4 mx-auto flex md:flex-row md:justify-start py-4 md:flex-nowrap">
                <Link
                  to="/contactenos"
                  className="md:relative  md:left-3/4"
                  style={{
                    backgroundColor: "#19235C",
                    color: "#FFFFFF",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "2px",
                    padding: "10px 5px 10px 10px",
                    fontSize: "16px",
                    cursor: "pointer",
                    color: "white",
                    border: "none",
                    borderRadius: "12px",
                  }}
                >
                  {t("banksSection.btnContactUs")}
                  <img
                    src={icon}
                    alt="right_arrow_icon"
                    className="button-icon  p-2"
                    style={{ width: "24px", height: "24px", color: "white" }}
                  />
                </Link>
              </div>
            </AnimatedElement>
          </div>
        </div>
      </section>

      {/**seccion iconos */}
      {/* <section style={{ display: "flex", flexDirection: "column" }}>
        <h4 className="my-8 text-lg text-customDarkBlue font-bold md:text-2xl w-3/4 mx-auto text-center">
          {t("banksSection.titleTrusted")}
        </h4>
        <img src={row1} alt="icon1" />
        <img src={row2} alt="icon2" />
      </section> */}

      {/* nueva seccion de soluciones */}
      <section>
        <h2 className="text-orangeAtm md:my-5 w-3/4 mx-auto text-4xl text-center font-bold md:text-7xl font-roboto mt-6 md:mt-10">
          {t("banksSection.solutions")}
        </h2>
        <div className="flex items-center ">
          {languageContext === "en" ? (
            <img src={imgIngles} alt="banks solutions" className="mx-auto" />
          ) : (
            <img src={soluciones1} alt="banks solutions" className="mx-auto" />
          )}
        </div>
      </section>

      {/**seccion  Servicios*/}
      <section className="bg-fontWhite py-16 px-4">
        <AnimatedElement
          fromDirection="topbancosservicios"
          style={{ fontFamily: "Helvetica", margin: "auto" }}
        >
          <h2 className="text-4xl md:text-6xl font-bold text-orangeAtm mb-12 text-center font-roboto">
            {t("banksSection.services")}
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 place-items-center max-w-7xl mx-auto">
            {/* Consultoría */}
            <div className="relative w-full max-w-[500px] h-[306px]">
              <img
                src={imgrect1}
                alt="consulting services"
                className="w-full h-full object-cover "
              />
              <h4 className="absolute bottom-4 left-4 bg-black/50 text-fontWhite px-4 py-2 rounded text-lg md:text-2xl font-bold">
                {t("retailSection.consulting")}
              </h4>
            </div>

            {/* Mantenimiento */}
            <div className="relative w-full max-w-[500px] h-[306px]">
              <img
                src={imgrect3}
                alt="mantainance services"
                className="w-full h-full object-cover "
              />
              <h4 className="absolute bottom-4 left-4 bg-black/50 text-fontWhite px-4 py-2 rounded text-lg md:text-2xl font-bold">
                {t("retailSection.mantainance")}
              </h4>
            </div>

            {/* Entrenamiento */}
            <div className="relative w-full max-w-[500px] h-[306px]">
              <img
                src={imgrect5}
                alt="training services"
                className="w-full h-full object-cover md:object-fill "
              />
              <h4 className="absolute bottom-4 left-4 bg-black/50 text-fontWhite px-4 py-2 rounded text-lg md:text-2xl font-bold">
                {t("retailSection.training")}
              </h4>
            </div>

            {/* Construcción */}
            <div className="relative w-full max-w-[500px] h-[306px]">
              <img
                src={imgrect4}
                alt="construction services"
                className="w-full h-full object-cover "
              />
              <h4 className="absolute bottom-4 left-4 bg-black/50 text-fontWhite px-4 py-2 rounded text-lg md:text-2xl font-bold">
                {t("banksSection.construction")}
              </h4>
            </div>

            {/* Almacén */}
            <div className="relative w-full max-w-[500px] h-[306px]">
              <img
                src={imgrect2}
                alt="warehouse services"
                className="w-full h-full object-cover "
              />
              <h4 className="absolute bottom-4 left-4 bg-black/50 text-fontWhite px-4 py-2 rounded text-lg md:text-2xl font-bold">
                {t("banksSection.warehouse")}
              </h4>
            </div>
          </div>
        </AnimatedElement>
      </section>

      {/**seccion Productos */}
      <section className="md:px-24">
        <h2 className="text-4xl md:text-6xl font-bold text-orangeAtm mb-12 text-center md:text-left font-roboto">
          {t("banksSection.products")}
        </h2>
        <div className="flex flex-col md:flex-row justify-center md:justify-between md:px-16">
          {/* Columna izquierda vacía o para otra información */}
          <div className="hidden md:block md:w-1/2"></div>

          {/* Columna derecha con el contenido */}
          <div className="w-full md:w-1/2">
            <ul className="list-disc pl-6">
              <li className="border-y border-orangeAtm text-xl md:text-3xl font-bold text-darkBlueText md:pt-2 md:pb-2">
                {t("banksSection.sellsAtms")}
                <br />
                {t("banksSection.refurbished")}
              </li>
              <li className="border-b border-orangeAtm text-xl md:text-3xl font-bold text-darkBlueText md:pt-2 md:pb-2">
                {t("banksSection.rentals")}
                <br />
                {t("banksSection.rebuilt")}
              </li>
              <li className="border-b border-orangeAtm text-xl md:text-3xl font-bold text-darkBlueText md:pt-2 md:pb-2">
                {t("banksSection.parts")}
              </li>
              <li className="border-b border-orangeAtm text-xl md:text-3xl font-bold text-darkBlueText md:pt-2 md:pb-2">
                {t("banksSection.fmlslm")}
              </li>
              <li className="border-b border-orangeAtm text-xl md:text-3xl font-bold text-darkBlueText md:pt-2 md:pb-2">
                {t("banksSection.atmSites")}
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}

export default SeccionBancos;
